import { ArgsType, Int, Field } from '@nestjs/graphql'

@ArgsType()
export class GetPlanInfoArgs {
  @Field(t => Int, { nullable: true })
  forUserId?: number

  @Field({ nullable: true })
  skipInvoices?: boolean
}
